<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'common.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'common.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ searchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'banner-ads.title' | translate }}</span>
  </ng-template>
  <button pButton type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'common.clear-search' | translate | uppercase }}</span>
  </button>
</div>
<div class="atlas-table mt-27">
  <p-table
    [showGridlines]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [value]="searchResult?.Result"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
    [lazy]="true"
    [paginator]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ProfileReportName">{{ 'banner-ads.search.results.profile' | translate | titlecase }}</th>
        <th pSortableColumn="Keyword">{{ 'banner-ads.search.results.keyword' | translate | titlecase }}</th>
        <th pSortableColumn="BannerName">{{ 'banner-ads.search.results.banner-name' | translate | titlecase }}</th>
        <th pSortableColumn="DisplayStartDate">{{ 'banner-ads.search.results.start-date' | translate | titlecase }}</th>
        <th pSortableColumn="DisplayEndDate">{{ 'banner-ads.search.results.end-date' | translate | titlecase }}</th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-banner>
      <tr>
        <td>
          <span *ngIf="banner.ProfileId > 0">{{ banner.ProfileReportName + ' (' + banner.ProfileId + ')' }}</span>
        </td>
        <td>{{ banner.Keyword }}</td>
        <td>{{ banner.BannerName }}</td>
        <td>{{ banner.DisplayStartDate | date: 'M/d/yyyy' }}</td>
        <td>{{ banner.DisplayEndDate | date: 'M/d/yyyy' }}</td>
        <td class="t-ac">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForBanner(banner)"> </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
</div>

<wl-banner-ad-edit-dialog (bannerSaved)="search()"></wl-banner-ad-edit-dialog>
<p-confirmDialog
  #cd
  key="deleteBannerAdCD"
  header="{{ 'banner-ads.search.confirm-delete-header' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
